/** Mga settings panel ng workflows phase 3: custom attributes at SLA policies. Isinasama sa `settings`. */
export const settingsP3 = {
  attributes: {
    title: "Mga attribute",
    subtitle: "Mga custom na field na maaaring itakda at pagbasehan ng mga workflow. Pinupunan ng inyong site ang mga ito gamit ang Sagot('identify'); ang mga step at staff ang magtatakda ng iba.",
    add: "Magdagdag ng attribute",
    addTitle: "Magdagdag ng attribute",
    editTitle: "I-edit ang attribute",
    dialogHint: "Hindi na mababago ang object, key at type kapag nagawa na ang attribute, dahil umaasa rito ang mga nakaimbak na halaga.",
    saved: "Na-save ang attribute",
    deleted: "Nabura ang attribute",
    deleteTitle: "Buburahin ang {{name}}?",
    deleteBody: "Mananatili ang mga halagang nakaimbak na sa mga bisita, usapan o lead, pero hindi na ito magagamit ng mga workflow.",
    delete: "Burahin",
    inUse: "Ginagamit pa rin ng mga workflow ang attribute na ito. Alisin muna ito sa kanilang mga step at kondisyon, saka burahin.",
    object: "Nabibilang sa",
    objects: { visitor: "Bisita", conversation: "Usapan", lead: "Lead" },
    type: "Uri",
    types: { text: "Teksto", number: "Numero", bool: "Oo / hindi", date: "Petsa", list: "Listahan ng mga pagpipilian" },
    label: "Pangalan",
    labelPlaceholder: "hal. Antas ng baitang",
    labelRequired: "Maglagay ng pangalan.",
    key: "Key",
    keyHint: "Maliliit na titik, numero at _, nagsisimula sa titik. Ginagamit sa mga workflow at ng identify.",
    keyInvalid: "Gumamit ng maliliit na titik, numero at _, nagsisimula sa titik (hanggang 40).",
    keyTaken: "May attribute na ang object na ito na may ganitong key.",
    options: "Mga pagpipilian",
    optionsHint: "Isa bawat linya, hanggang {{max}}.",
    optionsRequired: "Magdagdag ng kahit isang pagpipilian, hanggang {{max}}.",
    optionTooLong: "Hanggang {{max}} character ang bawat pagpipilian.",
    optionCount_one: "{{count}} pagpipilian",
    optionCount_other: "{{count}} pagpipilian",
    edit: "I-edit",
    editOne: "I-edit ang {{name}}",
    deleteOne: "Burahin ang {{name}}",
    actions: "Mga aksyon",
    save: "I-save ang attribute",
    emptyTitle: "Wala pang attribute",
    emptyBody: "Mag-define ng mga attribute tulad ng antas ng baitang o budget, saka itakda ang mga ito mula sa mga workflow o sa inyong site, at gamitin sa mga kondisyon.",
    limit: "Naabot na ang limitasyong {{max}} attribute. Magbura ng isa para makapagdagdag.",
  },
  sla: {
    title: "Mga SLA policy",
    subtitle: "Mga target sa pagtugon at paglutas na sinisimulan ng step na Ilapat ang SLA policy sa isang usapan.",
    add: "Magdagdag ng policy",
    addTitle: "Magdagdag ng SLA policy",
    editTitle: "I-edit ang SLA policy",
    dialogHint: "Nasa minuto ang mga target. Magsisimula ang orasan kapag inilapat ng workflow ang policy.",
    saved: "Na-save ang SLA policy",
    deleted: "Nabura ang SLA policy",
    deleteTitle: "Buburahin ang {{name}}?",
    deleteBody: "Mananatili ang mga target ng mga usapang tumatakbo na rito.",
    delete: "Burahin",
    inUse: "Inilalapat pa rin ng mga workflow ang policy na ito. Baguhin muna ang mga step na iyon, saka burahin.",
    gateTitle: "Nasa Institution plan ang mga SLA policy",
    gateBody: "Magtakda ng target sa unang tugon at paglutas, makita ang chip na Due in / Nalampasan sa Inbox, at balaan ang inyong team bago malampasan ang target.",
    name: "Pangalan",
    namePlaceholder: "hal. Priority ng admissions",
    nameRequired: "Maglagay ng pangalan.",
    nameTaken: "May SLA policy nang may ganitong pangalan.",
    firstResponse: "Unang tugon",
    nextResponse: "Susunod na tugon",
    resolution: "Paglutas",
    minutesHint: "Sa minuto, hanggang 365 araw.",
    minutesOf: "{{target}} sa minuto",
    officeHoursOnly: "Bilangin lamang ang oras ng opisina",
    warnBefore: "Babala bago",
    warnHint: "Ilang minuto bago ang target tatakbo ang mga workflow na “Bago malampasan ang SLA”. Gamitin ang 0 kung ayaw ng babala.",
    warnTooLong: "Dapat mas maaga ang babala kaysa sa pinakamaikli ninyong target.",
    save: "I-save ang policy",
    edit: "I-edit",
    editOne: "I-edit ang {{name}}",
    deleteOne: "Burahin ang {{name}}",
    actions: "Mga aksyon",
    clock: "Orasan",
    officeOnly: "Oras ng opisina",
    always: "Buong araw",
    emptyTitle: "Wala pang SLA policy",
    emptyBody: "Gumawa ng policy, saka magdagdag ng step na “Ilapat ang SLA policy” sa isang workflow.",
    limit: "Naabot na ang limitasyong {{max}} policy. Magbura ng isa para makapagdagdag.",
  },
} as const;
